module.exports = __webpack_public_path__ + "img/faq-empty-state.02c4cd0c.svg";